/** The pause menu drawn over a cave (docs/spec/07 §1). */

import type { Screen } from '../../render/screen';
import { BLACK, DARK_GREY, GREY, WHITE, YELLOW } from '../../render/palette';

export type PauseChoice = 'resume' | 'restart' | 'options' | 'quit';

export interface PauseItem {
  readonly id: PauseChoice;
  readonly label: string;
}

export function pauseItems(costsLife: boolean): PauseItem[] {
  return [
    { id: 'resume', label: 'RESUME' },
    { id: 'restart', label: costsLife ? 'RESTART CAVE (-1 LIFE)' : 'RESTART CAVE' },
    { id: 'options', label: 'OPTIONS' },
    { id: 'quit', label: 'QUIT TO TITLE' },
  ];
}

export interface PauseLayout {
  readonly x: number;
  readonly y: number;
  readonly w: number;
  readonly rowH: number;
  readonly firstRow: number;
}

export function pauseLayout(screen: { width: number; height: number }, items: readonly PauseItem[]): PauseLayout {
  const w = 216;
  const rowH = 14;
  const h = 34 + items.length * rowH;
  const x = Math.floor((screen.width - w) / 2);
  const y = Math.floor((screen.height - h) / 2) + 4;
  return { x, y, w, rowH, firstRow: y + 26 };
}

export function drawPause(screen: Screen, items: readonly PauseItem[], selected: number, anim: number): void {
  const L = pauseLayout(screen, items);
  const h = 34 + items.length * L.rowH;
  screen.fill(L.x + 3, L.y + 3, L.w, h, BLACK);
  screen.fill(L.x, L.y, L.w, h, DARK_GREY);
  screen.box(L.x, L.y, L.w, h, GREY);
  screen.box(L.x + 2, L.y + 2, L.w - 4, h - 4, BLACK);
  screen.text('PAUSED', L.x + L.w / 2, L.y + 9, WHITE, 'center');
  items.forEach((item, i) => {
    const y = L.firstRow + i * L.rowH;
    const on = i === selected;
    if (on) {
      screen.fill(L.x + 6, y - 3, L.w - 12, L.rowH - 1, BLACK);
      if ((anim >> 3) % 2 === 0) screen.text('►', L.x + 10, y, YELLOW);
    }
    screen.text(item.label, L.x + 24, y, on ? YELLOW : WHITE);
  });
}

/** Which item a virtual-screen point is over, or -1. */
export function pauseHit(screen: { width: number; height: number }, items: readonly PauseItem[], x: number, y: number): number {
  const L = pauseLayout(screen, items);
  if (x < L.x || x >= L.x + L.w) return -1;
  const i = Math.floor((y - (L.firstRow - 3)) / L.rowH);
  return i >= 0 && i < items.length ? i : -1;
}
